import React from 'react'
import NavBarHome from '../../components/NavBar/NavBarHome'
import Footer from '../../components/Footer/Footer'
import Masthead from './Masthead'
import ForumSections from './ForumSections'
import PopularDiscussions from './PopularDiscussions'
import CommunityEngagement from './CommunityEngagement'

function Community() {
   return (
      <div className="pt-[92px] flex flex-col min-h-screen">
         <NavBarHome />

         <Masthead />
         <ForumSections />
         <PopularDiscussions />
         <CommunityEngagement />

         <section>
            <Footer
               logo={"/Logo NextMaker.png"}
               bgColor="bg-dark-1"
               textColor="text-gray-100"
               borderColor="border-gray-400/20"
            />
         </section>
      </div>
   )
}

export default Community